import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Main from './components/Main';
import Partners from './components/Partners';
import PrivacyPolicy from './components/Privacy-Policy'; 
import TermsOfServices from './components/Terms-Of-Services'; 
import Index from './components/Index';
import NotFound from './components/NotFound';
import Talent from './components/Talent';
import About from './components/About';
import Team from './components/Team';
import Video from './components/Video';
import Hero from './components/Hero';

function App() {
  const location = useLocation();

  return (
    <div className="App">
      {location.pathname !== '/' && <Navbar />}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/TermsOfService" element={<TermsOfServices />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/Index" element={<Index />} />
        <Route path="/Team" element={<Team />} />
        <Route path="/About" element={<About />} />
        <Route path="/Partners" element={<Partners />} />
        <Route path="/Talent" element={<Talent />} />
        <Route path="/Video" element={<Video />} />
        <Route path="/Hero" element={<Hero />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      {location.pathname !== '/' && <Footer />}
    </div>
  );
}

export default App;
